import * as React from "react";
import { DifficultyLevel } from "../generic/difficultyLevel/DifficultyLevel";
export var PlayerProfileMedal = React.memo(function (_a) {
    var cupType = _a.cupType, difficultyLevel = _a.difficultyLevel, maxDifficulty = _a.maxDifficulty;
    return (React.createElement("div", { className: "flex flex--stacked flex--guts player-profile__cups-container" },
        React.createElement("div", { className: "player-profile-medal " + cupType }),
        React.createElement(DifficultyLevel, { difficultyLevel: difficultyLevel, difficultyLevelMax: maxDifficulty })));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/PlayerProfileMedal.tsx
// module id = 2874
// module chunks = 3